<div class="leader-board">
    <!-- <div class="right-info">
        <div><span *ngIf="numberPrizes" class="label" i18n>Prize distribution:</span><strong i18n>Top {{numberPrizes}} Players</strong></div>
        <div><span class="label" i18n>Minimum bet:</span><strong>{{minBet}} {{minBetCurrency}}</strong></div>
    </div> -->
    <ng-container *ngIf="rank && rank !== undefined; else noData">
        <div *ngIf="myPosition !== -1">
            <h3 i18n>Your current position:</h3>
            <div class="current-position" fxLayout="row" fxLayoutAlign="space-between center">
                <span class="my-position">{{myPosition>=0 ? myPosition+1 : '.'}}.</span>
                <div class="name-point-aria-cls">
                    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="9px">
                        <span>{{rank[myPosition]?.nickname}}</span>
                    </div>
                    <div>
                        {{rank[myPosition]?.points}}<span i18n>pts.</span>
                    </div>
                </div>
            </div>
        </div>
        <h2 i18n>Tournament Rank:</h2>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="list-wrap">
            <h3 i18n>Player</h3>
            <div i18n>Points</div>
        </div>
        <ul class="leader-list">
            <li fxLayout="row" [ngClass]="(myPosition===0) ? 'current-top': ''" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
                    <img src="{{licenceService.getKey('icon-gold-cup-1')}}" class="cup">
                    <span>{{rank[0]?.nickname}}</span>
                </div>
                <div>
                    {{rank[0]?.points}}
                </div>
            </li>
            <li fxLayout="row" [ngClass]="(myPosition===1) ? 'current-top': ''" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
                    <img src="{{licenceService.getKey('icon-gold-cup-2')}}" class="cup">
                    <span>{{rank[1]?.nickname}}</span>
                </div>
                <div>
                    {{rank[1]?.points}}
                </div>
            </li>
            <li *ngIf="rank.length > 1" fxLayout="row" [ngClass]="(myPosition===2) ? 'current-top': ''" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
                    <img src="{{licenceService.getKey('icon-gold-cup-3')}}" class="cup">
                    <span>{{rank[2]?.nickname}}</span>
                </div>
                <div>
                    {{rank[2]?.points}}
                </div>
            </li>
            <li [ngClass]="(myPosition===index+3) ? 'current-top': ''" *ngFor="let item of rank | slice:3:this.rankSize; let index = index;" fxLayout="row" fxLayoutAlign="space-between center">
                <div>
                    {{index+4}}. {{item.nickname}}
                </div>
                <div>
                    {{item.points}}
                </div>
            </li>
        </ul>
        <div *ngIf="!isShowMore && rank.length > 20" (click)="this.rankSize=SHOWMORE_RANK_LENGTH; isShowMore=true;" class="load-more">
            <a>
                <span i18n>Show More</span>
                <img src="{{licenceService.getKey('icon-right')}}" alt="arrow" icon-btn direction="bottom"/>
                <!-- <mat-icon>arrow_forward_ios</mat-icon> -->
            </a>
        </div>
    </ng-container>
    <ng-template #noData>
        <p class="no-data" i18n>The tournament has not started yet.</p>
    </ng-template>
</div>